import { useState } from 'react';
import { ChevronDown, ChevronRight, Link2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

function isValidUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

interface LinkSectionProps {
  value: string;
  onChange: (url: string) => void;
  disabled?: boolean;
}

export function LinkSection({ value, onChange, disabled }: LinkSectionProps) {
  const [open, setOpen] = useState(false);
  const valid = isValidUrl(value);

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground hover:text-foreground transition-colors"
      >
        {open ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />}
        <Link2 className="h-3.5 w-3.5" />
        Link
        <span className="normal-case font-normal text-muted-foreground/60">
          (shown on Twitter, LinkedIn, Facebook)
        </span>
      </button>

      {open && (
        <div className="mt-2 flex items-center gap-2">
          <Input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="https://example.com"
            disabled={disabled}
            className={cn(
              'text-sm h-8',
              'w-full text-[14px] rounded-[10px] outline-none transition-all duration-150 shadow-social-card',
              'h-[40px] px-3 py-3 !font-mono',
              'text-primary',
              'placeholder-[var(--input-placeholder)]',
            )}
          />
          {valid && (
            <span className="shrink-0 text-xs text-muted-foreground border border-border rounded px-2 py-0.5">
              Preview on save
            </span>
          )}
        </div>
      )}
    </div>
  );
}
